import { GOODS_TYPES } from 'constants/sales'

const PRODUCT_NAME_FALLBACKS = {
  [GOODS_TYPES.dnaConsultation]: 'Консультация генетика',
  [GOODS_TYPES.nutritionConsultation]: 'Консультация нутрициолога',
}

export const openCloudPaymentsWidget = (orderData) => {

    if (typeof window === 'undefined' || !window.cp) {
      return null
    }

    const {cart, dict, sales} = orderData;

    const widget = new window.cp.CloudPayments();

    const goods = Object.keys(cart.goods).map((key) => {
      return {
        key,
        name:
          dict.sections[key] ||
          dict.kits?.[key]?.title ||
          sales?.goods?.[key]?.name ||
          PRODUCT_NAME_FALLBACKS[key] ||
          key,
        ...cart.goods[key]
      }
    }).filter(item => item.amount > 0)

    const receipt = {
      "Items": [],
      "email": cart.personal.email || '',
      "customerInfo": cart.personal.name || '',
      "amounts":
        {
          "electronic": Number(cart.sum.cost.toFixed(2)), // Сумма оплаты электронными деньгами
        }
    };

    goods.map(item => {
      receipt.Items.push({
        "label": item.name, //наименование товара
        "measurementUnit": "шт", //единица измерения
        "price": Number((item.cost / item.amount).toFixed(2)), //цена
        "quantity": item.amount, //количество
        "amount": item.cost, //сумма
        "method": 4,
        "object": 4,
      })
    })

    const data = { //содержимое элемента data
      CloudPayments: {
        CustomerReceipt: receipt, //онлайн-чек
      }
    };

    widget.pay('charge',
      {
          publicId: process.env.server.PUBLIC_CLOUDPAYMENTS_SHOP_ID,
          description: `Оплата заказа №${orderData.invoiceId}`,
          amount: orderData.amount,
          currency: 'RUB',
          disableEmail: true,
          successRedirectUrl: `https://atlas.ru/cart/status/?order=${orderData.invoiceId}`,
          invoiceId: orderData.invoiceId,
          data: data,
          skin: "modern",

      },
      {
          onSuccess: () => {
              window.location.href = `https://atlas.ru/cart/status/?order=${orderData.invoiceId}`
          },

          onFail: () => {
          },

          onComplete: () => {
            window.location.href = `https://atlas.ru/cart/status/?order=${orderData.invoiceId}`
          },
      }
  )
  }
